import axios from 'axios';

export const getEnvVar = (key, fallback) => {
  const value = process.env[key];
  if (value && value.trim().length > 0) {
    return value;
  }

  return fallback;
};

const getBaseUrl = () => {
  const envUrl = getEnvVar('REACT_APP_API_BASE_URL', '');
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return 'https://samovars-backend.onrender.com';
  }

  return 'http://localhost:5002';
};

export const API_BASE_URL = getBaseUrl();

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default API_BASE_URL;

